import { Helmet } from 'react-helmet-async';

const SITE_URL = 'https://www.axeoservices-cergy.fr';
const SITE_NAME = 'AXEO Services Cergy';

/**
 * Titre + meta description + canonical + Open Graph propres à chaque page.
 * `path` est le chemin relatif (ex: "/particuliers") utilisé pour l'URL canonique et og:url.
 */
export function Seo({ title, description, path = '', image }) {
  const fullTitle = title ? `${title} | ${SITE_NAME}` : SITE_NAME;
  const url = `${SITE_URL}${path}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      <link rel="canonical" href={url} />
      <meta property="og:title" content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
    </Helmet>
  );
}
